import { render, staticRenderFns } from "./ManualResourceEntries.vue?vue&type=template&id=6d8ec014&scoped=true&"
import script from "./ManualResourceEntries.vue?vue&type=script&lang=js&"
export * from "./ManualResourceEntries.vue?vue&type=script&lang=js&"
import style0 from "./ManualResourceEntries.vue?vue&type=style&index=0&id=6d8ec014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ec014",
  null
  
)

export default component.exports